const postcodeJSON = require("./postcodes.min.json");

export const getDistanceBetween = (
  latitude1,
  longitude1,
  latitude2,
  longitude2
) => {
  const degreesToRadians = degrees => {
    return degrees * (Math.PI / 180);
  };

  let deltaLat = latitude2 - latitude1;
  let deltaLon = longitude2 - longitude1;
  let earthRadius = 6369087; // in meters; 3959 in miles.
  let alpha = deltaLat / 2;
  let beta = deltaLon / 2;
  let a =
    Math.sin(degreesToRadians(alpha)) * Math.sin(degreesToRadians(alpha)) +
    Math.cos(degreesToRadians(latitude1)) *
      Math.cos(degreesToRadians(latitude2)) *
      Math.sin(degreesToRadians(beta)) *
      Math.sin(degreesToRadians(beta));
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let distance = earthRadius * c;
  return distance.toFixed(2) / 1000; //divide by 1000 for km
};

export const getPostcodeData = postcode => {
  const postcodeData = postcodeJSON.filter(entry => {
    return entry.postcode === +postcode;
  })[0];

  if (!postcodeData) {
    return {
      postcode: null,
      longitude: null,
      latitude: null
    };
  }

  return postcodeData;
};
